<template>
  <ElDialog
    :visible="value"
    :title="$t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY')"
    width="500px"
    @close="closeAndReset"
  >
    <TwoStepsPreview :steps="stepTitles" :active-step="activeStep" />

    <AddDiscoveryCampaignGeneralInformation
      v-show="activeStep === 0"
      :apps="apps"
      :reset-controller="resetController"
      :is-loading="isLoading"
      @submit="nextStep"
    />
    <AddDiscoveryCampaignCityAndPriceSetting
      v-show="activeStep === 1"
      :is-loading="isLoading"
      :reset-controller="resetController"
      :credit="credit"
      @back="prevStep"
      @submit="addCampaign"
    />
  </ElDialog>
</template>

<script>
import { DiscoveryAdsCampaigns } from '@/api/api';
import TwoStepsPreview from './TwoStepsPreview';
import AddDiscoveryCampaignGeneralInformation from './AddDiscoveryCampaignGeneralInformation';
import AddDiscoveryCampaignCityAndPriceSetting from './AddDiscoveryCampaignCityAndPriceSetting';
import { campaignTypes } from '../../../common/constants.js';
import createController from '@/utils/controller';
const resetController = createController('reset');

export default {
  name: 'AddDiscoveryCampaignModal',

  components: {
    TwoStepsPreview,
    AddDiscoveryCampaignGeneralInformation,
    AddDiscoveryCampaignCityAndPriceSetting,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    apps: {
      type: Array,
      required: true,
    },
    credit: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      activeStep: 0,
      isLoading: false,
      campaignModel: {
        name: '',
        packageName: '',
        startDate: '',
        endDate: '',
        targetedCpi: '',
        budget: '',
        dailyCap: '',
        paused: false,
        impressionTrackerLink: '',
      },
    };
  },
  computed: {
    stepTitles() {
      return this.steps.map(step => step.title);
    },
    resetController() {
      return resetController;
    },
    steps() {
      return [
        {
          title: this.$t(
            'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.STEPS.GENERAL_INFO',
          ),
          component: 'AddDiscoveryCampaignGeneralInformation',
        },
        {
          title: this.$t(
            'ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.STEPS.SET_PRICE',
          ),
          component: 'AddDiscoveryCampaignCityAndPriceSetting',
        },
      ];
    },
  },
  methods: {
    closeAndReset() {
      this.$emit('input', false);
      resetController.reset();
      this.activeStep = 0;
    },
    setData(data) {
      for (let prop in data) {
        if (prop in this.campaignModel) {
          this.campaignModel[prop] = data[prop];
        }
      }
    },
    nextStep(data) {
      if (this.activeStep >= this.steps.length - 1) return;
      this.setData(data);
      this.activeStep++;
    },
    prevStep() {
      if (this.activeStep <= 0) return;
      this.activeStep--;
    },
    addCampaign(data) {
      this.setData(data);
      this.isLoading = true;

      return DiscoveryAdsCampaigns.addCampaign(this.campaignModel)
        .then(message => {
          this.$message.success(message);
          this.closeAndReset();
          this.$emit('add', campaignTypes.DISCOVERY);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
